const NEUTRAL_SECONDARY = '#605e5c';

export const getStyles = () => ({
  'reports-v4-email-picker': {
    '& .checkbox input[type="checkbox"]': {
      float: 'left',
    },
    '& .checkbox > label :nth-child(n+3)': {
      marginLeft: '8px',
    },
    '& .email-notification-delivery-option-editor__search-box': {
      marginBottom: '5px',
    },
    '& .email-notification-delivery-option-editor__user-list': {
      border: `1px solid ${NEUTRAL_SECONDARY}`,
      padding: '10px',
      overflowY: 'auto',
      maxHeight: '300px',
    },
  },
});
